var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerCharge1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2345_65032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.0269 0C19.342 0 8.25 11.0786 8.25 24.75C8.25 38.4147 33.0269 66 33.0269 66C33.0269 66 57.8039 38.4147 57.8039 24.75C57.8039 11.0786 46.7118 0 33.0269 0ZM33.0269 41.25C23.9082 41.25 16.5067 33.862 16.5067 24.75C16.5067 15.638 23.9014 8.25 33.0269 8.25C42.1524 8.25 49.5471 15.638 49.5471 24.75C49.5471 33.862 42.1524 41.25 33.0269 41.25Z",
    fill: "#70B4F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2345_65032"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerCharge1);
export default __webpack_public_path__ + "static/media/marker-charge1.078f4a11d8c9c2d9b58e064f9c791e42.svg";
export { ForwardRef as ReactComponent };